var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRealEstateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#5B93FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1348 38.7733V35.7156C27.1348 34.9351 27.7722 34.3023 28.5584 34.3023H31.4326C31.8102 34.3023 32.1723 34.4512 32.4393 34.7163C32.7063 34.9813 32.8563 35.3408 32.8563 35.7156V38.7733C32.8539 39.0978 32.9821 39.4099 33.2124 39.6402C33.4427 39.8705 33.7561 40 34.0829 40H36.0438C36.9596 40.0023 37.8388 39.6428 38.4872 39.0008C39.1356 38.3588 39.5 37.487 39.5 36.5778V27.8669C39.5 27.1325 39.1721 26.4358 38.6046 25.9647L31.934 20.6759C30.7737 19.7486 29.1111 19.7785 27.9854 20.747L21.467 25.9647C20.8727 26.422 20.5176 27.1206 20.5 27.8669V36.5689C20.5 38.4639 22.0474 40 23.9562 40H25.8723C26.5512 40 27.103 39.4562 27.1079 38.7822L27.1348 38.7733Z",
    fill: "#5B93FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateIcon);
export default __webpack_public_path__ + "static/media/real_estate_icon.d27132387c5abef59e4425c4d8ac41ca.svg";
export { ForwardRef as ReactComponent };